import { patientUpsertModalRouteStore } from '../domain/upsert-modal-store';

export default (showing = true) => {
  patientUpsertModalRouteStore.setValue('showingDeleteConfirmationModal', showing);
};
